webpackJsonp([162898551421021],{

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        marginTop: '30vh'
	      }
	    },
	    _react2.default.createElement(
	      'h1',
	      null,
	      '404'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'How\'d you even get here?'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' },
	      'go back'
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-eaff86baf7bb4fa81842.js